<template>
  <div id="app">
    <div class="app-wrap">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  mounted () {

  }
}
</script>

<style lang="scss">
  html {
    position: relative;
    min-height: 0;
    overflow-x: auto;
  }

  body {
    overflow-x: auto;
    background-color: white;
  }
  #app {

  }

  .app-wrap {
    padding-bottom: 0;
    margin-bottom: 0;
  }
</style>
